export const DESK_ESTONIA_HEIGHT = 615;
export const DESK_HEIGHT_BANNER = 215;
export const MOBILE_ESTONIA = 376;
export const MOBILE_HEIGHT = 560;

export enum ExpLobbyFocusOnWelcomeAndReg {
  A = 'exp_lu_lobby_focus_on_welcome_and_reg_ver_a',
  B = 'exp_lu_lobby_focus_on_welcome_and_reg_ver_b',
}

export const getSlideHeight = (
  elementHeight: number,
  isMobile: boolean,
  isEstonia: boolean,
  mobHeight: number,
  mobEstoniaHeight: number,
  deskHeight: number,
  deskEstoniaHeight: number
) => {
  const contentHeight = elementHeight || 0;

  if (isEstonia) {
    return isMobile ? mobEstoniaHeight : deskEstoniaHeight;
  }

  return contentHeight + (isMobile ? mobHeight : deskHeight);
};
